/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import FormTextInput from 'components/forms/form-text-input';
import FormLabel from 'components/forms/form-label';
import { exportConnectionSale } from 'state/connections/actions';
import { successNotice, errorNotice } from 'state/notices/actions';
import JumpingDots from 'components/jumping-dots';

/**
 * Style dependencies
 */
import './styles.scss';

const ExportSale = ({ connectionId, connectionType, ...props }) => {
   
    const [value, setValue] = useState('');
    const [requesting, setRequesting] = useState(false);
   
    const handleExportSale = async (connectionId, saleId) => {
        setRequesting(true);
        try {
            await props.exportConnectionSale(connectionId, saleId);
            props.successNotice('Sale added to processing queue');
            setValue('');
        } catch (error) {
            props.errorNotice('Failed to export sale')
        }
        setRequesting(false);

    };

    const handleOnSubmit = (e) => {
        e.preventDefault();
        handleExportSale(connectionId, value);
    };

    const handleOnChange = (e) => {
        setValue(e.target.value);
    };

    const disabled = requesting;

    return (
        <form onSubmit={handleOnSubmit}>
            <FormLabel for='saleId' className="connection-sales__export-label">order number</FormLabel>
            <Box style={{ opacity: '0.7' }} marginBottom='medium'>
                <Text size='xsmall'>Enter the order number on your eCommerce platform to export sale.</Text>
            </Box>
            <Box className='connection-sales__export-sale' display='flex' alignItems='center'>
                <FormTextInput disabled={disabled} name='saleId' onChange={handleOnChange} value={value} />
                <Button disabled={disabled} type = 'submit' marginLeft='large'>
                    {requesting ? <div>Exporting <JumpingDots /></div>  : "Export"}
                </Button>
            </Box>
        </form>
    );
};

export default connect(null, {
    exportConnectionSale,
    successNotice,
    errorNotice
})(ExportSale);
